import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import * as navHelpers from '../../helpers/navHelpers';
import * as actions from '../../actions/index';

import './App.css';
import Section from '../Section/Section';
import HorizontalNav from '../HorizontalNav/HorizontalNav';
import HorizontalSubNav from '../HorizontalSubNav/HorizontalSubNav';

import LoadScreen from '../LoadScreen/LoadScreen';
import Modal from '../Modal/Modal';
import UnityContent from '../UnityContent/UnityContent';

import appData from '../../data/app.json';

class App extends Component {
	// constructor(props) {
	// 	super(props);
	// }

	goToSection(sectionNumber) {
		this.props.goToSection(sectionNumber);
	}

	goToStage(stageNumber) {
		this.props.goToStage(stageNumber);
		// left this in for now
	}

	render() {
		return (
			<main className="app">
				{
					!this.props.loader &&
					<HorizontalNav
						title={'Section navigation'}
						navItems={navHelpers.getSectionNames(appData)}
						currentSection={this.props.currentSection}
						currentGroup={this.props.currentGroup}
						currentStage={this.props.currentStage}
						onClick={this.goToSection.bind(this)}
					/>
				}
				{
					<UnityContent data={appData} />
				}
				{
					this.props.loader &&
					<LoadScreen />
				}

				{
					this.props.modal !== null &&
					<Modal />
				}

				<Section
					currentSection={this.props.currentSection}
					currentGroup={this.props.currentGroup}
					currentStage={this.props.currentStage}
				/>

				{appData && appData.sections && appData.sections[this.props.currentSection] &&
					!appData.sections[this.props.currentSection].hideSubNav &&
					appData.sections[this.props.currentSection].groups[this.props.currentGroup] &&
					<HorizontalSubNav
						data={appData.sections[this.props.currentSection].groups[this.props.currentGroup].stages}
						currentSection={this.props.currentSection}
						currentGroup={this.props.currentGroup}
						currentStage={this.props.currentStage}
					/>
				}
			</main>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentSection: state.navigation.currentSection,
		currentGroup: state.navigation.currentGroup,
		currentStage: state.navigation.currentStage,
		modal: state.navigation.modal,
		loader: state.navigation.loader,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		goToSection: (sectionID) => {
			dispatch(actions.goToSection(sectionID));
		},
		goToStage: (stageID) => {
			dispatch(actions.goToStage(stageID));
		},
		setLoader: (bool) => {
			dispatch(actions.setLoader(bool));
		}
	};
}

App.propTypes = {
	currentSection: propTypes.number.isRequired,
	currentStage: propTypes.number,
	goToStage: propTypes.func.isRequired,
	goToSection: propTypes.func.isRequired,
	setLoader: propTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js